const Setup = {
  PSEUDO: false,
  APP_NAME: 'Blue Current',
  FALLBACK_LANG: 'nl',
};

export default Setup;
